import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const tradingToken = localStorage.getItem('kotak_trading_token');

  if (!tradingToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
